import { useCallback, useRef, useEffect, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getUrlParam } from '@diezhi/momo';
import lottiePlayCV from '@@/animation/lottiePlayCV/data.json';
import NavBarM from '@@/components/NavBarM';
import PlayBtn from '@@/components/PlayBtn';
import useDisplayImage from '@/src/hooks/useDisplayImage';

import Doc1 from './img/character_doc_1.png';
import Doc2 from './img/character_doc_2.png';
import Doc3 from './img/character_doc_3.png';
import Doc4 from './img/character_doc_4.png';
import Doc5 from './img/character_doc_5.png';

import styles from './style.module.scss';

const docList = [Doc1, Doc2, Doc3, Doc4, Doc5];

const CharacterDetail = ({
  pageData,
}) => {
  const swiperRef = useRef();
  const displayImage = useDisplayImage();

  const downloadData = useMemo(() => {
    return {
      dIos: pageData?.dIos?.[0].value || '',
      dAndroid: pageData?.dAndroid[0].value || '',
    };
  }, [pageData]);

  const onSwiper = useCallback((swiper) => {
    swiperRef.current = swiper;
  }, []);

  const onClickChangeSlide = (direction) => {
    const swiper = swiperRef.current;
    if (direction === 'prev') {
      swiper.slidePrev();
    } else {
      swiper.slideNext();
    }
  };

  const showDoc = (index) => {
    displayImage(docList[index].src);
  };

  useEffect(() => {
    const initialIndex = Number(getUrlParam('index', window.location.href)) || 0;
    if (initialIndex) {
      swiperRef.current.slideTo(initialIndex);
    }
  }, []);

  return (
    <div className={styles.container}>
      <NavBarM external downloadData={downloadData} />
      <div
        className={styles.prev}
        onClick={() => {
          onClickChangeSlide('prev');
        }}
      />
      <div
        className={styles.next}
        onClick={() => {
          onClickChangeSlide('next');
        }}
      />
      <Swiper
        style={{ height: '100%' }}
        slidesPerView="auto"
        onSwiper={onSwiper}
        initialSlide={0}
        allowTouchMove
        loop
      >
        {/* 背景图 */}
        {new Array(5).fill('').map((_, index) => (
          <SwiperSlide key={index}>
            <div className={`${styles.characterBg} character${index + 1}`}>
              <div className={styles.actionWrap}>
                <div
                  className={styles.doc}
                  onClick={() => {
                    showDoc(index);
                  }}
                />
                <div className={styles.cv} />
                <PlayBtn className={styles.playVoiceBtn} name={`cvMusic${index + 1}`} lottie={lottiePlayCV} />
                <div className={styles.roleMusic} />
                <PlayBtn className={styles.playMusicBtn} name={`roleMusic${index + 1}`} />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CharacterDetail;
